var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2304 18.0348L19.2304 18.0331L15.2354 14.0364L15.443 13.759C18.2071 10.0652 17.4534 4.83007 13.7596 2.06599C10.0659 -0.698089 4.83071 0.0555851 2.06663 3.74936C-0.697448 7.44313 0.0562258 12.6783 3.75 15.4424C6.71714 17.6627 10.7924 17.6627 13.7596 15.4424L14.0371 15.2347L18.1547 19.3524C18.4852 19.6828 19.0209 19.6828 19.3513 19.3524C19.6818 19.0219 19.6818 18.4862 19.3513 18.1558L19.2304 18.0348ZM2.15836 8.78644C2.15836 12.4474 5.12612 15.4152 8.78708 15.4152C12.4462 15.4113 15.4119 12.4455 15.4158 8.78644C15.4158 5.12548 12.448 2.15772 8.78708 2.15772C5.12612 2.15772 2.15836 5.12548 2.15836 8.78644Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.cce1fa622bb6071312611334a6e74676.svg";
export { ForwardRef as ReactComponent };